import { Section, TagsGroup } from "@/components";
import "./Tags.scss";

type Props = {
  title: string;
  items: any[];
};

export const Tags = ({ title, items = [] }: Props) => {
  return (
    <Section className="ui-tags-section">
      <Section.Title
        fs={"6"}
        mdFs={"6"}
        as={"h1"}
        color={"slate-28"}
        className="ui-tags-items-section-title"
      >
        {title}
      </Section.Title>
      <TagsGroup topics={items} />
    </Section>
  );
};
